export default function (instance) {
    return {
        auth(payload){
            return instance.postForm('sms-login', payload)
        },
        authCallGate(payload){
            return instance.postForm('user/create-login-phone', payload)
        },
        checkAuthCallGate(payload){
            return instance.postForm('user/check-login-phone', payload)
        },
        registration(payload){
            return instance.postForm('user', payload)
        },
    }
}